import {ThemeColorPath} from '../types/ThemePaths';

/**
 * Converts foundation theme color path to Tailwind color class name
 * Transforms dot notation to kebab-case
 * @example getColorByPath('general.accent') → 'general-accent'
 * @example getColorByPath('severity.warning') → 'severity-warning'
 * @example getColorByPath('palettes.blue.60.100') → 'palette-blue-60-100'
 */
export const getColorByPath = (path: ThemeColorPath): string =>
  path.replace(/\./g, '-').replace(/^palettes-/, 'palette-');
